/**
 * Polls a function at a given interval
 * @param fn Function to be called
 * @param delay Time in milliseconds
 * @returns A function that clears the interval and stops the polling
 */
const poll = <T>(fn: () => T, delay: number) => {
  const call = () => {
    fn();
  };

  const interval: NodeJS.Timer = setInterval(call, delay);

  return () => clearInterval(interval);
};

export default poll;
